import React from 'react';
import { StateManagementProps } from '../../utils/addReduxProps';
import { translate, WithNamespaces } from 'react-i18next';
import formatter from '../../utils/formatter';
import './ConfigurationSummary.scss';
import { Grid, } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Close from '@material-ui/icons/Close';
import VehicleImage from '../vehicle-overview/VehicleImage';
import { Part } from '../parts/PartsList';
import { RouteComponentProps } from 'react-router';
import { Setup } from '../setups/SetupsList';
import { ShowDialogProps } from '../../redux/actions';
import { DialogTypes } from '../../enums/dialogTypes';
import DialogRouter from '../dialogs/dialogRouter';
import { sortAscendingByProperty } from '../../utils/helpers';
import NotVisualizedIcon from '@material-ui/icons/VisibilityOffOutlined';
import _ from 'lodash';

export type ConfigurationSummaryProps = StateManagementProps & WithNamespaces & RouteComponentProps<{ modelId: string }>;

export const ConfigurationSummary: React.FunctionComponent<ConfigurationSummaryProps> = (props) => {
	const {
		t,
		appliedSetup,
		selectedModel,
		totalPrice,
		models: { ShowPricesInConfigurator: hasPrices },
		match: { params: { modelId } },
		showDialog, 
		categories
	} = props;
	const hasRacingComponent = props.appliedParts.find(part => part.Racing);
	// open export dialog
	const showExportDialog = () => {
		const dialogProps: ShowDialogProps = {
			title: t('dialogs.exportConfiguration.title'),
			data: {},
			contentType: DialogTypes.exportConfiguration,
		}
		showDialog(dialogProps);
	}

	const shareConfiguration = () => {
		const dialogProps: ShowDialogProps = {
			title: t('dialogs.shareConfiguration.title'),
			data: {},
			contentType: DialogTypes.shareConfiguration,
		}
		showDialog(dialogProps);
	}

	const parts = _.uniqBy(props.appliedParts, 'PartId')

	return (
		<div className="configurationSummaryContainer flex-container column">
			<div>
				<Close className="closeBtn" onClick={() => { props.toggleSummary(false) }} />
				<h2>{selectedModel.Name}</h2>
				{hasRacingComponent && <p>{t('configuration.summary.racingInfo')}
					&nbsp;
				<span className="racingComponent">{t('configuration.summary.ece')}</span>
				</p>}
			</div>
			<Grid item container className="grow">
				<Grid item xs={6} className="vehicleData">
					<section>
						{appliedSetup && <h3>{(appliedSetup as Setup).Name}</h3>}
						{props.appliedParts.length > 0 &&
							<h4>
								<span className="powerParts">{t('configuration.summary.powerParts')}</span>
								&nbsp;{t('configuration.summary.addedParts')}
							</h4>
						}
						<ul className="componentList">
							{parts
								.sort(sortAscendingByProperty<Pick<Part, 'Name'>>('Name'))
								.map((part: Part, index: number) => {
									const pathToPart = `/configuration/${modelId}/categories/${categories.indexOf(part.CategoryName).toString()}#${part.PartId}`
									return (
										<Link key={index} to={`${pathToPart}`} className="clickable">
											<li>
												<span className="componentName">{part.Name}
													&nbsp;
                          <span className="ktm-orange-color">{part.PartId}</span>
													&nbsp;
													{part.Racing && <span className="racingComponent">{t('configuration.summary.ece')}</span>}
													&nbsp;
													{!part.CanBeRendered && <NotVisualizedIcon titleAccess={t('configuration.parts.notVisualized')}></NotVisualizedIcon>}
												</span>
												<span className="componentPrice">{formatter.currency(part.Price)}</span>
											</li>
										</Link>
									);
								})}
						</ul>
					</section>
				</Grid>
				<Grid item xs={6}>
					<div className="imageContainer">
						<VehicleImage arrowStyle={{ left: '12px' }} imageClassName="initial-height" useDarkFont={true} />
						<div className="full-width">
							<Grid item xs={12} className="priceContainer">
								{hasPrices &&
									<><h3>{t('configuration.summary.total')} { /*appliedSetup */ true ? formatter.currency(totalPrice) : "-"} </h3>
										<p id="extra-cost-info">{t('configuration.summary.piceInfo')}</p>
									</>}
							</Grid>
							<div className="flex-container justify-end full-width">
								<div>
									<button className="secondary" onClick={showExportDialog}>{t('buttons.export')}</button>
									<div className="button-separator" />
									<button className="primary" onClick={shareConfiguration}>{t('buttons.share')}</button>
								</div>
							</div>
						</div>
					</div>
				</Grid>
			</Grid>
			<DialogRouter />
		</div>
	)
}

export default translate()(ConfigurationSummary);
